module.exports = "<toaster-container></toaster-container>\r\n<spinner [backgroundColor]=\"'#ff0000'\"></spinner>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main